import React from 'react'

import './WinScreen.scss'
import { fCurrency } from 'helpers/common'
import { PriceRange } from 'hooks/useDetailedBetResult'
import Background from 'assets/win_screen_point_bg.png'
import Speedometer from 'assets/animation/win_speedometer.webp'
import { useAppContext } from 'context/AppContext'

interface WinScreenProps {
  priceRange: PriceRange
  percentageChange: string
}

const WinScreen: React.FC<WinScreenProps> = ({
  priceRange,
  percentageChange,
}) => {
  const { pointsSettings } = useAppContext()

  return (
    <div className="WinScreen">
      <div className="WinScreen__title">Win</div>

      <div>
        <div className="WinScreen__percentage">
          <span>BTC Price</span>{' '}
          <span className="WinScreen__percentage-percent">
            {percentageChange}%
          </span>
        </div>
        <div className="WinScreen__price-range">
          From {fCurrency(priceRange.from)} to {fCurrency(priceRange.to)}
        </div>
      </div>

      <img width={450} src={Speedometer} alt="Speedometer" />

      <div className="WinScreen__main-points-wrapper">
        <div className="WinScreen__points-wrapper">
          <div className="WinScreen__points">+ {pointsSettings?.win} pts</div>
        </div>

        <img
          className="WinScreen__points-bg"
          width={480}
          height={129}
          src={Background}
          alt="background"
        />
      </div>
    </div>
  )
}

export default WinScreen
